import { IValue } from '../types/value.interface';

export function getValueNumber(value?: number | IValue) {
  const stringValue = (value as IValue)?.['@value'];

  return value ? (stringValue ? parseInt(stringValue, 10) : (value as number)) : undefined;
}
